import React, {useEffect, useState} from 'react'
import {ListGroup} from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'

import folderIcon from '../../../../../_metronic/assets/images/svg/data-room/blue-folder-icon.svg'
// import DownArrowIcon from '../../../../../_metronic/assets/images/svg/data-room/ic-down-arrow.svg'
// import RightArrowIcon from '../../../../../_metronic/assets/images/svg/data-room/ic-right-arrow.svg'
import '../../styles/FileManagerRecords.scss'
import {getFileType} from '../../../../core/_util'
import {useNavigate} from 'react-router-dom'
import {Dropdown} from 'react-bootstrap'
import threeDots from '../../../../../_metronic/assets/images/svg/investor/threeDots.svg'
import {useIntl} from 'react-intl'
import ViewDocModal from '../../../stakeholders/stakeholders-and-investors/components/individual/view-doc-modal'
import {useAuth} from '../../../auth'
import {
  createAccess,
  createActivityLog,
  deleteClassification,
  deleteFile,
  getViewAndDownloadFile,
} from '../../core/_requests'
import {toast} from 'react-toastify'
import {RenameFileOrFolderModal} from '../RenameFileOrFolderModal'
import {DeleteClassificationModal} from '../RecordsClassifications/DeleteClassificationModal'
import {getLocation} from '../../../onboarding/core/_requests'
import { NoDataPage } from '../../../resources/components/NoDataPage'
import ThreadTitle from '../../../AI-banker/components/shortenString'
import { useThemeMode } from '../../../../../_metronic/partials'

export const FolderTreeView: React.FC<any> = ({
  folderStructure,
  setFolderStructure,
  selectedPath,
  handleFolderClick,
  handleDoubleFolderClick,
  selectedFoldersData,
  isFileStructureLoading,
  isStorageLoading,
  setSelectedFolders,
  localExpanded,
  setLocalExpanded,
  getFolderOrFileList,
  setSelectedPath,
  loading,
}) => {
  // const isSingleClickRef = useRef(false)
  // const [loadingFolder, setLoadingFolder] = useState<string | null>(null) // Track the currently loading folder
  const navigate = useNavigate()
  const {formatMessage} = useIntl()
  const [type, setType] = useState()
  const [openDeleteConfirmationModal, setOpenDeleteConfirmationModal] = useState<boolean>(false)
  const [recordId, setRecordId] = useState('')
  const [currentFolderLevel, setCurrentFolderLevel] = useState()
  const [isActive, setIsActive] = useState(false)
  const [fileName, setFileName] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [viewableData, setViewableData] = useState<
    {downloadUrl: string; fileName: string; extension: string} | {}
  >({})
  const {companyId, currentUser} = useAuth()
  const [showRenameModal, showRenameShowModal] = useState(false)
  const [folderOrFileName, setFolderOrFileName] = useState('')
  const [versionId, setVersionId] = useState()
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false)
  const [selectedIndex, setSelectedIndex] = useState<any>({
    level: '',
    id: '',
    uuid: '',
  })
  const [fileCount, setFileCount] = useState()
  useEffect(
    () => {
      setLocalExpanded(() => {
        const updatedExpanded: any = {}

        // Ensure all keys in selectedPath are set to true
        selectedPath.forEach((path: string) => {
          updatedExpanded[path] = true
        })

        return updatedExpanded
      })
    },
    // eslint-disable-next-line
    [selectedPath] // eslint-disable-line react-hooks/exhaustive-deps
  )

  // const toggleFolderExpansion = async (
  //   folderId: string,
  //   folderLevel: string,
  //   year: number | null,
  //   quarter: string | undefined,
  //   month: string | undefined,
  //   folderName: string,
  //   children: any
  // ) => {
  //   // const collapseChildren = (children: any) => {
  //   //   Object.keys(children).forEach((key) => {
  //   //   setLocalExpanded((prev) => ({...prev, [key]: false}));
  //   //   if (children[key].children) {
  //   //     collapseChildren(children[key].children);
  //   //   }
  //   //   });
  //   // };

  //   if (folderName in localExpanded) {
  //     if (localExpanded[folderName]) {
  //       setLocalExpanded((prev: Record<string, boolean>) => ({...prev, [folderName]: false}))
  //       // collapseChildren(children);
  //     } else {
  //       setLocalExpanded((prev: Record<string, boolean>) => ({...prev, [folderName]: true}))
  //     }

  //     return
  //   }
  //   // Check if children are already loaded
  //   if (children && Object.keys(children).length > 0) {
  //     if (children[folderName] in localExpanded) {
  //       setLocalExpanded((prev: Record<string, boolean>) => ({...prev, [folderName]: true}))
  //     } else {
  //       setLocalExpanded((prev: Record<string, boolean>) => ({...prev, [folderName]: true}))
  //     }
  //     return
  //   }
  //   // Otherwise, load the folder
  //   setLoadingFolder(folderName.split('$-@')[0])

  //   try {
  //     await handleFolderClick(folderId, folderLevel, year, quarter, month)
  //     setLocalExpanded((prev: Record<string, boolean>) => ({...prev, [folderName]: true})) // Expand the folder after loading
  //   } finally {
  //     setLoadingFolder(null)
  //   }
  // }

  const getDeviceType = () => {
    const ua = navigator.userAgent

    if (
      /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera Mobi|Blazer|Dolfin|Dolphin|Skyfire|Zune/.test(
        ua
      )
    ) {
      return 'MOBILE'
    }
    return 'WEB'
  }

  const getOS = () => {
    const ua = navigator.userAgent
    if (/iPhone|iPad|iPod|Macintosh/.test(ua)) return 'APPLE'
    if (/Win/.test(ua)) return 'WINDOWS'
    if (/android/i.test(ua)) return 'ANDROID'
    return 'Unknown'
  }

  const createActivity = async (recordId: any) => {
    const os = getOS()
    const deviceTypeView = getDeviceType()
    const locationApiData = await getLocation()
    const city = locationApiData?.data.country_name
    const ipAddress = locationApiData?.data?.ip
    try {
      if (deviceTypeView && os && city && recordId && companyId) {
        const {
          data: {success, errors},
        } = await createActivityLog(
          companyId,
          recordId,
          os,
          deviceTypeView,
          city,
          ipAddress,
          'VIEWED'
        )
        if (!success) {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  const createAccessLog = async (recordId: any) => {
    const os = getOS()
    const deviceTypeView = getDeviceType()
    const locationApiData = await getLocation()
    const city = locationApiData?.data.country_name
    const ipAddress = locationApiData?.data?.ip

    try {
      if (deviceTypeView && os && city && recordId && companyId && currentUser?.userId) {
        const {
          data: {success, errors},
        } = await createAccess(
          recordId,
          os,
          deviceTypeView,
          city,
          ipAddress,
          'CREATE',
          companyId,
          currentUser?.userId
        )
        if (!success) {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }
  const [selectedConversation, setSelectedConversation] = useState<string | null>(null)
  const handleSelectConversation = (index: string) => {
    setSelectedConversation(index)
  }
  const {mode} = useThemeMode()
  
  const FolderTree = ({data, path}: {data: any; path: string[]}) => {
    return (
      <ListGroup>
        {!isStorageLoading &&
          !isFileStructureLoading &&
          data &&
          Object.entries(data).length === 0 && (
            <>
            <NoDataPage/>
            </>
          )}
        {Object.entries(data).sort(([folderNameA], [folderNameB]) =>
      folderNameA.localeCompare(folderNameB)
    ) // Sort folder names alphabetically (ascending)
    .map(([folderName, folderData]: [string, any], index: number) => {
          const isFolder = folderData.type === 'folder'
          // const isExpanded = localExpanded[`${folderName}$-@${folderData.id}`] || false
          return (
            <>
              <div key={folderName}>
                <ListGroup.Item
                  action
                  active={
                    JSON.stringify(path.concat(`${folderName}$-@${folderData.id}`)) ===
                    JSON.stringify(selectedPath)
                  }
                  onClick={() => {      
                    handleSelectConversation(folderData.id)              
                    if (isFolder) {
                      setSelectedPath([])
                      selectedFoldersData.current = [...selectedFoldersData.current, folderData]
                      handleDoubleFolderClick(
                        [...path, `${folderName}$-@${folderData.id}`],
                        data[folderName],
                        folderName,
                        undefined,
                        true,
                        true
                      )                    
                    }                    
                  }}
                  className={`border-0 rounded-2 p-2 position-relative ${
                    selectedConversation?.trim() === folderData.id
                      ? mode === 'dark'
                        ? `selected-class-dark`
                        : `selected-class`
                      : ''
                  }`}
                >
                  <div className='d-flex align-items-center gap-2'>
                    {isFolder ? (
                      <div className={`d-flex gap-2 align-items-center justify-content-between w-100`}>
                        <div className='d-flex align-items-center gap-2' style={{maxWidth: '80%'}}>                          
                          <img src={folderIcon} alt='Folder Icon' />                                                    
                          <ThreadTitle title={folderName.includes('Not Known') ? 'Not Known' : folderName} />                      
                        </div>
                        <div className='d-flex justify-content-between ms-4 dropdown-container'>
                          <Dropdown
                            show={
                              selectedIndex?.id === folderData?.id &&
                              selectedIndex.level === folderData.currentFolderLevel &&
                              selectedIndex.uuid === folderData.uuid
                            }
                            onToggle={(isOpen) => {
                              setSelectedIndex(
                                isOpen
                                  ? {
                                      level: folderData.currentFolderLevel,
                                      id: folderData.id,
                                      uuid: folderData.uuid,
                                    }
                                  : undefined
                              )
                            }}
                            onClick={(e) => {
                              e.stopPropagation()
                            }}
                          >
                            <Dropdown.Toggle className='btn btn-white table-three-dots dots-container'>
                              <img src={threeDots} alt='three-dots' className='three-dots-image' />
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              className='m-2'
                              style={{
                                width: '130px',
                                position: 'absolute',
                                zIndex: 1050,
                                top: '100%',
                                left: '0',
                                right: '0',
                              }}
                            >
                              <Dropdown.Item
                                className='rounded-top'
                                onClick={() => {
                                  selectedFoldersData.current = [
                                    ...selectedFoldersData.current,
                                    folderData,
                                  ]
                                  handleDoubleFolderClick(
                                    [...path, `${folderName}$-@${folderData.id}`],
                                    data[folderName],
                                    folderName,
                                    undefined,
                                    true,
                                    true
                                  )
                                }}
                              >
                                {formatMessage({id: 'Open Folder'})}
                              </Dropdown.Item>
                              {folderData.currentFolderLevel === 'LevelThree' ||
                              folderData.currentFolderLevel === 'LevelThreeQuarter' ||
                              folderData.currentFolderLevel === 'LevelThreeMonth' ? null : (
                                <Dropdown.Item
                                  onClick={() => {
                                    showRenameShowModal(true)
                                    setType(folderData.type)
                                    setVersionId(folderData.fileVersionId)
                                    setRecordId(folderData.id)
                                    setCurrentFolderLevel(folderData.currentFolderLevel)

                                    setFolderOrFileName(
                                      folderData.type === 'file'
                                        ? folderName.split('.')[0]
                                        : folderName
                                    )
                                  }}
                                >
                                  {formatMessage({id: 'Rename'})}
                                </Dropdown.Item>
                              )}
                              {folderData.currentFolderLevel === 'LevelThree' ||
                              folderData.currentFolderLevel === 'LevelThreeQuarter' ||
                              folderData.currentFolderLevel === 'LevelThreeMonth' ? null : (
                                <Dropdown.Item
                                  className='text-danger rounded-bottom'
                                  onClick={() => {
                                    setType(folderData.type)
                                    setOpenDeleteConfirmationModal(true)
                                    setRecordId(folderData.id)
                                    setCurrentFolderLevel(folderData.currentFolderLevel)
                                    setFileCount(folderData.numberOfFiles)
                                  }}
                                >
                                  {formatMessage({id: 'Delete Folder'})}
                                </Dropdown.Item>
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </div>
                    ) : (
                      <div className='d-flex justify-content-between w-100'>
                        <div
                          className='d-flex flex-row align-items-center gap-2 ms-4'
                          onClick={() => {
                            navigate('/rk/records-and-files/files-details/' + folderData.id)
                            createActivity(folderData.id)
                          }}
                        >
                          <img
                            src={getFileType(folderData.fileVersionName)}
                            alt={folderName}
                            style={{height: '30px', width: '30px'}}
                          />
                          <p className='m-0 wrap-word'>{folderName.split('.')[0]}</p>
                        </div>
                        <div className='d-flex justify-content-between ms-4 dropdown-container'>
                          <Dropdown
                            show={
                              selectedIndex?.id === folderData?.id &&
                              selectedIndex.level === folderData.currentFolderLevel &&
                              selectedIndex.uuid === folderData.uuid
                            }
                            onToggle={(isOpen) => {
                              setSelectedIndex(
                                isOpen
                                  ? {
                                      level: folderData.currentFolderLevel,
                                      id: folderData.id,
                                      uuid: folderData.uuid,
                                    }
                                  : undefined
                              )
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <Dropdown.Toggle className='btn btn-white table-three-dots dots-container'>
                              <img src={threeDots} alt='three-dots' className='three-dots-image' />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className='m-2 '>
                              <Dropdown.Item
                                onClick={() => {
                                  setFileName(folderData.name)
                                  createAccessLog(folderData.id)
                                  handleViewFile(folderData.fileVersionId)
                                }}
                              >
                                Open File
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  showRenameShowModal(true)
                                  setType(folderData.type)
                                  setVersionId(folderData.fileVersionId)
                                  setRecordId(folderData.id)
                                  setCurrentFolderLevel(folderData.currentFolderLevel)
                                  setFolderOrFileName(folderName)
                                }}
                              >
                                {formatMessage({id: 'Rename'})}
                              </Dropdown.Item>
                              <Dropdown.Item
                                className='text-danger'
                                onClick={() => {
                                  setType(folderData.type)
                                  setOpenDeleteConfirmationModal(true)
                                  setRecordId(folderData.id)
                                  setCurrentFolderLevel(folderData.currentFolderLevel)
                                }}
                              >
                                {formatMessage({id: 'Delete File'})}
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </div>
                    )}
                  </div>
                </ListGroup.Item>                
              </div>
            </>
          )
        })}
      </ListGroup>
    )
  }

  const handleViewFile = async (fileVersionId: string) => {
    if (!companyId) return

    //  setIsActive (true)
    setIsActive(true)
    setIsLoading(true)
    try {
      const {
        data: {data, success},
      } = await getViewAndDownloadFile(fileVersionId, companyId)
      if (success) {
        setViewableData(data)
      }
    } catch (error) {
      toast.error('Failed to download document')
    } finally {
      setIsLoading(false)
    }
  }

  const handleDeleteFolder = async () => {
    if (!companyId) return
    if (!currentFolderLevel) return
    if (!recordId) return
    try {
      setDeleteLoading(true)

      const {
        data: {success, errors},
      } = await deleteClassification(companyId, recordId, currentFolderLevel)
      if (success) {
        toast.success(`Folder deleted successfully`)
        setSelectedPath([])
        setSelectedFolders([])
        getFolderOrFileList('LevelOne')
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
      }
    } catch (err) {
      console.log(err)
      toast.error('Failed to delete folder')
    } finally {
      setDeleteLoading(false)
      setOpenDeleteConfirmationModal(false)
      setRecordId('')
    }
  }

  // And similarly for handleDeleteFile:
  const handleDeleteFile = async () => {
    if (!companyId) return
    if (!currentFolderLevel) return
    try {
      setDeleteLoading(true)
      if (recordId) {
        const {
          data: {success, errors},
        } = await deleteFile(recordId, companyId)
        if (success) {
          // Update the folder structure locally
          toast.success(`File deleted successfully`)
          setSelectedPath([])
          setSelectedFolders([])
          getFolderOrFileList('LevelOne')
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
      toast.error('Failed to delete file')
    } finally {
      setDeleteLoading(false)
      setOpenDeleteConfirmationModal(false)
      setRecordId('')
    }
  }

  return (
    <div>
      {(isStorageLoading || (isFileStructureLoading  && !loading)) &&
      (folderStructure || Object.keys(folderStructure).length === 0) ? (
        <div className='global-spinner'>
          <div>
            <Skeleton
              width={'100%'}
              height={40}
              count={15}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
              style={{borderRadius: '5px'}}
            />
          </div>
        </div>
      ) : (
        <FolderTree data={folderStructure} path={[]} />
      )}

      <ViewDocModal
        isActive={isActive}
        setIsActive={setIsActive}
        fileName={fileName}
        isRecordKeeper={true}
        isLoading={isLoading}
        viewableData={viewableData}
      />

      <RenameFileOrFolderModal
        showRenameModal={showRenameModal}
        showRenameShowModal={showRenameShowModal}
        type={type}
        versionId={versionId}
        currentFolderLevel={currentFolderLevel}
        recordId={recordId}
        folderOrFileName={folderOrFileName}
        folderStructure={folderStructure}
        setFolderStructure={setFolderStructure}
        setSelectedFolders={setSelectedFolders}
        setLocalExpanded={setLocalExpanded}
        setSelectedPath={setSelectedPath}
      />

      <DeleteClassificationModal
        setDeleteShowModal={setOpenDeleteConfirmationModal}
        showDeleteModal={openDeleteConfirmationModal}
        handleDelete={type === 'folder' ? handleDeleteFolder : handleDeleteFile}
        deleteLoading={deleteLoading}
        headingMessage={type === 'folder' ? `Delete Folder` : 'Delete File'}
        warningText={type === 'folder' ? '' : 'This will permanently delete the file.'}
        description={
          type === 'folder'
            ? `This ${
                currentFolderLevel === 'LevelOne'
                  ? 'Departments'
                  : currentFolderLevel === 'LevelTwo'
                  ? 'Category'
                  : 'Project'
              } has ${fileCount} numbers of files. Do you still want to delete it? You can not undo this action.`
            : `Are you sure you want to delete this File?`
        }
      />
    </div>
  )
}
